import { defineStore } from 'pinia';

export const promptStore = defineStore('prompt-store', {
    state: () => {
        return {
            showError: false,
            message: '',
        };
    },

    getters: {
        errorMessage(state) {
            return state.message;
        },

        showErrorMessage(state) {
            return state.showError;
        },
    },

    actions: {
        async displayErrorMessage(status, message) {
            this.message = message;
            this.showError = true;
        },

        async hideError() {
            this.showError = false;
        },
    },
});
